import axios, { Method } from 'axios'

export const axiosCall = function (url: string, method: Method, data: any = null) {
    const onSuccess = function (response: any) {
        return response.data;
    }
    const onError = function (error: any) {
        console.error('Request Failed:', error.config);

        if (error.response) {
            console.error('Status:', error.response.status);
            console.error('Data:', error.response.data);
            console.error('Headers:', error.response.headers);

        } else {
            console.error('Error Message:', error.message);
        }

        return Promise.reject(error.response || error.message);
    }

    return axios({
        method: method,
        url: url,
        data: data
      }).then(onSuccess)
      .catch(onError);
}
